import React, { useRef } from "react";
import { useIntersection } from "../../hooks";

interface iSection extends React.HTMLProps<HTMLDivElement> {
  title: string;
  leftChildren?: React.ReactNode;
}
const Section: React.FC<iSection> = (props) => {
  const { title, className, children, id } = props;
  const divRef = useRef(null);
  const sectionRef = useIntersection(divRef, "0px");

  return (
    <div
      id={id}
      ref={divRef}
      className={
        " flex flex-col pt-2 pb-8 gap-4 phone:justify-start phone:items-start mt-8  transition-all duration-[2000ms]   " +
        (sectionRef ? " visible opacity-100 " : "  invisible opacity-0 ")
      }
    >
      <div className="flex flex-row w-full">
        <h1 className="text-3xl font-bold flex-1">
          {title || "Place to title"}
        </h1>
        <div>{props.leftChildren}</div>
      </div>
      <div className={" " + className}>{children}</div>
    </div>
  );
};

export default Section;
